var map = {
	"./auto-grow-textarea_controller.js": 225,
	"./correcties_controller.js": 226,
	"./delete_controller.js": 227,
	"./drag_controller.js": 228,
	"./dropfile_controller.js": 266,
	"./hello_controller.js": 229
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;